import { nullish, object } from 'valibot'
import { richTextData, singleLineData } from '~/utils/crystallize/component-schemas'
import { crystallizeDocumentSchema } from '~/utils/crystallize/document'

export const newsletterSchema = crystallizeDocumentSchema(
  'newsletter',
  object({
    title: nullish(singleLineData),
    leadParagraph: nullish(richTextData),
    hubspotFormId: nullish(uuidSchema),
    formTitle: nullish(singleLineData),
  }),
)
